import {
	Button,
	ChipConfirmModal,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from "@ondit/ui";
import { ArrowDown, ArrowUp, MoreHorizontal, Trash2 } from "lucide-react";
import { type ReactNode, useState } from "react";
import { useT } from "~/core/i18n";

export function ArticleActions({
	label,
	disabled,
	up,
	down,
	remove,
	children,
}: {
	label: string;
	disabled: boolean;
	up?: () => void;
	down?: () => void;
	remove: () => void;
	children?: ReactNode;
}) {
	const t = useT();
	const [confirm, setConfirm] = useState(false);
	return (
		<>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button
						type="button"
						variant="ghost"
						size="icon"
						disabled={disabled}
						className="article-action-trigger"
						aria-label={label}
						title={label}
					>
						<MoreHorizontal />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="start">
					<DropdownMenuLabel>{label}</DropdownMenuLabel>
					{children}
					{up && (
						<DropdownMenuItem onSelect={up}>
							<ArrowUp />
							{t("editor.moveUp")}
						</DropdownMenuItem>
					)}
					{down && (
						<DropdownMenuItem onSelect={down}>
							<ArrowDown />
							{t("editor.moveDown")}
						</DropdownMenuItem>
					)}
					<DropdownMenuItem className="text-[var(--text-error)]" onSelect={() => setConfirm(true)}>
						<Trash2 />
						{t("editor.remove")}
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
			<ChipConfirmModal
				open={confirm}
				onOpenChange={setConfirm}
				title={t("editor.remove")}
				text={t("common.removeConfirm")}
				dismissLabel={t("common.cancel")}
				confirm={{ label: t("common.remove"), variant: "destructive", onClick: remove, disabled: disabled }}
			/>
		</>
	);
}
